import _ from "lodash";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_LEAVE_GET_REQUESTS_BY_CONTRACT,
  MY_LEAVE_REQUESTS_BY_CONTRACT_SUBSCRIPTION,
} from "my-leave/graphql";
import { useOcPolling } from "oc/hooks";

export const useReqestLeavesData = ({
  selectedYear,
  contractCode,
}: {
  selectedYear: string;
  contractCode: string;
}) => {
  const { data, error } = useQuery(MY_LEAVE_GET_REQUESTS_BY_CONTRACT, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    skip: !contractCode,
    variables: { contract: contractCode, year: selectedYear },
  });

  if (error) {
    console.log({
      component: "MyLeaveRequests",
      errorDescription:
        "Error occured when fetch data with MY_LEAVE_GET_REQUESTS_BY_CONTRACT query",
      error: error,
    });
  }

  const { data: subscriptionData, error: subscriptionError } = useSubscription(
    MY_LEAVE_REQUESTS_BY_CONTRACT_SUBSCRIPTION,
    {
      fetchPolicy: "network-only",
      variables: { contract: contractCode, year: selectedYear },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "MyLeaveRequests",
      errorDescription:
        "Error occured when subscribe data with MY_LEAVE_REQUESTS_SUBSCRIPTION query",
      error: error,
    });
  }

  interface LeaveRequest {
    startDate: string;
    type: string;
    state: string;
    leaveType: string;
    effectiveWorkDays: number;
    // add other properties if needed
  }

  let resultData =
    subscriptionData?.leaveRequestsByContract ||
    data?.leaveRequestsByContract ||
    [];

  let result = _.cloneDeep(resultData) as LeaveRequest[];

  let requestedLeaveDays = {
    base: 0,
    study: 0,
    covid: 0,
    eszjtv: 0,
    emergency: 0,
  };

  for (const item of result) {
    const now = new Date(selectedYear);
    const itemDate = new Date(item?.startDate);
    const inCurrentYear = now.getFullYear() === itemDate.getFullYear();

    if (item.type === "leave" && item.state === "requested" && inCurrentYear) {
      if (item.leaveType === "Q") {
        requestedLeaveDays.covid =
          requestedLeaveDays.covid + item.effectiveWorkDays;
      } else if (item.leaveType === "D") {
        requestedLeaveDays.eszjtv =
          requestedLeaveDays.eszjtv + item.effectiveWorkDays;
      } else if (item.leaveType === "T") {
        requestedLeaveDays.study =
          requestedLeaveDays.study + item.effectiveWorkDays;
      } else if (item.leaveType === "V") {
        requestedLeaveDays.emergency =
          requestedLeaveDays.emergency + item.effectiveWorkDays;
      } else {
        requestedLeaveDays.base =
          requestedLeaveDays.base + item.effectiveWorkDays;
      }
    }
  }

  return { contractCode, selectedYear, requestedLeaveDays };
};

export default useReqestLeavesData;
